module.exports = __webpack_public_path__ + "static/media/AG-Associates.062b3672.png";